/**
 * The cues on the player's timeline while the Subtitles tab is open (1.9.0, the ShotTicks pattern): a thin segment
 * per cue along the bottom of the bar, neutral grey, the selected ones in the accent colour, a cue with a warning in
 * amber and one with an error in red.
 */
import { useMemo } from 'react';
import { TICKS_PER_SECOND, type Cue, type TrackStyle } from '@prism/contracts';
import { cueSeverities } from '../subtitles/stripMath';

export function CueTicks({ cues, selectedIds, duration, trackStyle }: { cues: readonly Cue[]; selectedIds: readonly string[]; duration: number; trackStyle?: TrackStyle | null }) {
  const severities = useMemo(() => cueSeverities(cues, trackStyle, Math.round(duration * TICKS_PER_SECOND)), [cues, trackStyle, duration]);
  if (!(duration > 0)) return null;
  const sel = new Set(selectedIds);
  const pct = (t: number) => `${Math.max(0, Math.min(100, (t / TICKS_PER_SECOND / duration) * 100))}%`;
  return (
    <div className="cue-ticks" aria-hidden data-testid="cue-ticks">
      {cues.map((c) => {
        const severity = severities.get(c.id);
        return (
          <span key={c.id} className={`cue-tick ${sel.has(c.id) ? 'selected' : ''} ${severity ?? ''}`} data-cue={c.id} data-severity={severity}
            style={{ left: pct(c.startTicks), width: `max(2px, calc(${pct(c.endTicks)} - ${pct(c.startTicks)}))` }} />
        );
      })}
    </div>
  );
}
